import React, { useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import cn from 'classnames'

import Card from '../blog/Card'
import { PostDataType } from '@/types'

import styles from './relatedBlog.module.scss'

interface RelatedBlogProps {
  categorizedPosts: Record<string, PostDataType[]>
}

export default function RelatedBlog({ categorizedPosts }: RelatedBlogProps) {
  const posts = categorizedPosts['health-insurance'] || []

  /* Swiper Handlers   */
  const ref = useRef(null)

  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  const goNext = async () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      await ref.current.swiper.slideNext()
      setIsBeginning(ref.current?.swiper?.isBeginning)
      setIsEnd(ref.current?.swiper?.isEnd)
    }
  }

  const goPrev = async () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      await ref.current.swiper.slidePrev()
      setIsBeginning(ref.current?.swiper?.isBeginning)
      setIsEnd(ref.current?.swiper?.isEnd)
    }
  }

  if (!posts.length) return null

  return (
    <div className={styles.main}>
      <div className={styles.section}>
        <h2>Pet Health Tips & Advice</h2>

        <div
          className={cn({
            [styles.cards]: true,
            [styles.noWrap]: true,
          })}
        >
          <button
            className={cn({
              [styles.swiperButton]: true,
              [styles.swiperPrev]: !isBeginning,
              [styles.disabledPrev]: isBeginning,
            })}
            onClick={goPrev}
          />
          <button
            className={cn({
              [styles.swiperButton]: true,
              [styles.swiperNext]: !isEnd,
              [styles.disabledNext]: isEnd,
            })}
            onClick={goNext}
          />
          <div className={styles.scroll}>
            <div className={styles.cardWrapper}>
              <Swiper
                speed={1000}
                slidesPerView={4}
                initialSlide={0}
                autoplay={{
                  disableOnInteraction: true,
                }}
                grabCursor
                breakpoints={{
                  1020: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                  },
                  860: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  540: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                  },
                  360: {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                  },
                }}
                ref={ref}
              >
                {posts?.map((p, i) => (
                  <SwiperSlide key={i}>
                    <div className={styles.pair}>
                      <Card
                        key={p.slug}
                        slug={p.slug}
                        title={p.title}
                        image={p.metadata?.image?.imgix_url}
                        readingTime={p.metadata?.reading_time}
                        details
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
